import { CButton, CSpinner } from "@coreui/react";
import { requester } from "App";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BasicPagination from "routes/front/main/vending/mainPage/layout/process/pagination/BasicPagination";
import style from "./AdminProductList.module.css";
import clsx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { useTranslation } from "react-i18next";
import { far } from "@fortawesome/free-regular-svg-icons";

function AdminProductList(props) {
    const [products, setProducts] = useState([]);
    const [allProducts, setAllProducts] = useState([]); // 전체 상품 데이터 
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [categoryList, setCategoryList] = useState();
    const [selectedCategory, setSelectedCategory] = useState(undefined);
    const textRef = useRef(); // 검색 input을 위한 ref
    const itemsPerPage = 10;
    const { t } = useTranslation();

    const headers = ['productImg', 'productName', 'supplyPrice', 'price', 'quantity', 'etc'];

    const handleEdit = (product) => {
        navigate(`/admin/product/list/${product.id}`, { state: { data: product } })
    };

    const handleDelete = (product) => {
        const data = {
            id: product.id
        }
        requester.deleteProduct(data, (result) => {
            if (result.data) {
                setProducts(prevProducts =>
                    prevProducts.map(p =>
                        p.id === result.data.id
                            ? { ...p, valid: result.data.valid }
                            : p
                    )
                );
            } else {
                toast.error("error!!")
            }
        });
    };

    const handleEventToggle = (product) => {
        requester.toggleEventProduct({ id: product.id }, (result) => {
            if (result.data) {
                setProducts(prevProducts =>
                    prevProducts.map(p =>
                        p.id === product.id
                            ? { ...p, eventYn: !p.eventYn }
                            : p
                    )
                );
            }
        });
    };

    const handleRecommendedToggle = (product) => {
        requester.toggleRecommendedProduct({ id: product.id }, (result) => {
            if (result.data) {
                setProducts(prevProducts =>
                    prevProducts.map(p =>
                        p.id === product.id
                            ? { ...p, recommendedYn: !p.recommendedYn }
                            : p
                    )
                );
            }
        });
    };

    const handleNewProductToggle = (product) => {
        requester.toggleNewProduct({ id: product.id }, (result) => {
            if (result.data) {
                setProducts(prevProducts =>
                    prevProducts.map(p =>
                        p.id === product.id
                            ? { ...p, newYn: !p.newYn }
                            : p
                    )
                );
            }
        });
    };

    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            if (result && key in result) {
                result = result[key];
            } else {
                return undefined;
            }
        }
        return result;
    }

    // 검색 클릭 핸들러 추가
    const onSearchClick = () => {
        const keyword = textRef.current.getValue().toLowerCase();

        // 전체 상품에서 검색
        const filteredProducts = allProducts.filter(product =>
            product.productName.toLowerCase().includes(keyword) ||
            product.supplyPrice.toString().toLowerCase().includes(keyword) ||
            product.price.toString().toLowerCase().includes(keyword)
        );

        setProducts(filteredProducts);
        setCurrentPage(1); // 첫 페이지로 리셋
        setSelectedCategory(undefined); // 카테고리 선택 초기화
    };

    // 검색 초기화 핸들러 추가
    const onRefreshClick = () => {
        setProducts(allProducts);
        setCurrentPage(1);
        setSelectedCategory(undefined);
    };

    const handleSelectedCategory = (category) => {
        if (selectedCategory === category) {
            setSelectedCategory(undefined)
        } else
            setSelectedCategory(category)
    }

    const filteredList = selectedCategory !== undefined
        ? products.filter((data) => data.categoryId === selectedCategory.id)
        : products;

    const totalPages = Math.ceil(filteredList.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const displayedList = filteredList.slice(startIndex, startIndex + itemsPerPage);

    useEffect(() => {
        let data = { storeId: "root" }
        requester.findAllProducts(data, (result) => {
            setAllProducts(result.data); // 전체 상품 데이터 저장
            setProducts(result.data); // 현재 표시할 상품 데이터
        })

        requester.openfindAllCategory((result) => {
            const filteredSubCategories = result.data.filter(category => category.parentCategoryId != null);
            setCategoryList(filteredSubCategories);
        });
    }, [])

    useEffect(() => {
        setCurrentPage(1)
    }, [selectedCategory])

    return (
        <Container>
            <VerticalFlex gap={30}>
                {/* 검색 섹션 추가 */}
                <FlexChild>
                    <HorizontalFlex gap={10} alignItems={"flex-start"} justifyContent={"flex-start"}>
                        <FlexChild maxWidth={"400px"}>
                            <InputText ref={textRef} onEnterPress={onSearchClick} />
                        </FlexChild>
                        <FlexChild width={"initial"}>
                            <div className={style.searchButton} onClick={onSearchClick}>
                                <SquareWrapper width={34.5}>
                                    <Center>
                                        <FontAwesomeIcon fontSize={20} icon={fas["faSearch"]} color={"var(--main-color)"} />
                                    </Center>
                                </SquareWrapper>
                            </div>
                        </FlexChild>
                        <FlexChild width={"initial"}>
                            <div className={style.searchButton} onClick={onRefreshClick}>
                                <SquareWrapper width={34.5}>
                                    <Center>
                                        <FontAwesomeIcon fontSize={20} icon={fas["faRedo"]} color={"var(--main-color)"} />
                                    </Center>
                                </SquareWrapper>
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <div className={style.categorySection}>
                        {categoryList && categoryList.map((category) => (
                            <div key={category.id}  className={clsx(style.categoryButton, { [style.selected]: category.categoryName === selectedCategory?.categoryName })} onClick={() => handleSelectedCategory(category)}>
                                <P>
                                    {category.categoryName}
                                </P>
                            </div>
                        ))}
                    </div>
                </FlexChild>
                <FlexChild>
                    <div className={style.searchResultSection} style={{ overflowX: 'auto' }}>
                        <table className={style.table}>
                            <thead>
                                <tr>
                                    {headers.map((header) => (
                                        <th className={style.th} key={header}>{t(header)}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {displayedList && displayedList.map((item, index) => (
                                    <tr
                                        key={index}
                                        style={{
                                            backgroundColor: item.valid === false ? 'rgba(255, 0, 0, 0.1)' : 'transparent',
                                            color: item.valid === false ? 'red' : 'inherit'
                                        }}
                                    >
                                        {headers.slice(0, -1).map((header) => (
                                            <td className={style.td}
                                                style={{
                                                    textDecoration: item.valid === false ? 'line-through' : 'none'
                                                }}
                                                key={`${index}-${header}`}
                                            >
                                                {header.endsWith('Img') && getNestedValue(item, header) ? (
                                                    <SquareWrapper width={50}>
                                                        <Center>
                                                            <img
                                                                src={getNestedValue(item, header)}
                                                                alt="Product"
                                                                style={{
                                                                    maxWidth: '50px',
                                                                    maxHeight: '50px',
                                                                    opacity: item.valid === false ? 0.5 : 1
                                                                }}
                                                            />
                                                        </Center>
                                                    </SquareWrapper>

                                                ) : (
                                                    getNestedValue(item, header)
                                                )}
                                            </td>
                                        ))}
                                        <td className={style.td}>
                                            <HorizontalFlex alignItems={"center"} justifyContent={"center"}>
                                                <FlexChild width={"initial"}>
                                                    <div className={style.button} onClick={() => handleEdit(item)}>
                                                        <SquareWrapper width={34.5}>
                                                            <Center>
                                                                <FontAwesomeIcon fontSize={20} icon={fas["faEdit"]} color={"var(--main-color)"} />
                                                            </Center>
                                                        </SquareWrapper>
                                                    </div>
                                                </FlexChild>
                                                {/* 이벤트 상품 토글 버튼 */}
                                                <FlexChild width={"initial"}>
                                                    <div
                                                        className={style.button}
                                                        onClick={() => handleEventToggle(item)}
                                                        title="이벤트 상품"
                                                    >
                                                        <SquareWrapper width={34.5}>
                                                            <Center>
                                                                <FontAwesomeIcon
                                                                    fontSize={20}
                                                                    icon={fas["faStar"]}
                                                                    color={item.eventYn ? "var(--main-color)" : "#ccc"}
                                                                />
                                                            </Center>
                                                        </SquareWrapper>
                                                    </div>
                                                </FlexChild>
                                                {/* 추천 상품 토글 버튼 */}
                                                <FlexChild width={"initial"}>
                                                    <div
                                                        className={style.button}
                                                        onClick={() => handleRecommendedToggle(item)}
                                                        title="추천 상품"
                                                    >
                                                        <SquareWrapper width={34.5}>
                                                            <Center>
                                                                <FontAwesomeIcon
                                                                    fontSize={20}
                                                                    icon={fas["faThumbsUp"]}
                                                                    color={item.recommendedYn ? "var(--main-color)" : "#ccc"}
                                                                />
                                                            </Center>
                                                        </SquareWrapper>
                                                    </div>
                                                </FlexChild>
                                                {/* 신상품 토글 버튼 */}
                                                <FlexChild width={"initial"}>
                                                    <div
                                                        className={style.button}
                                                        onClick={() => handleNewProductToggle(item)}
                                                        title="신상품"
                                                    >
                                                        <SquareWrapper width={34.5}>
                                                            <Center>
                                                                <FontAwesomeIcon
                                                                    fontSize={20}
                                                                    icon={fas["faTag"]}
                                                                    color={item.newYn ? "var(--main-color)" : "#ccc"}
                                                                />
                                                            </Center>
                                                        </SquareWrapper>
                                                    </div>
                                                </FlexChild>
                                                <FlexChild width={"initial"}>
                                                    <div className={style.button} onClick={() => handleDelete(item)} >
                                                        <SquareWrapper width={34.5}>
                                                            <Center>
                                                                <FontAwesomeIcon fontSize={20} icon={far["faTrashAlt"]} color={"var(--main-color)"} />
                                                            </Center>
                                                        </SquareWrapper>
                                                    </div>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </FlexChild>
                <FlexChild maxWidth={1200}>
                    <BasicPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default AdminProductList;